export const getMonthName = (date) => {
  const language = window.cultureInfo
    || document.documentElement.lang
    || navigator.language
    || navigator.languages[0];
  const monthName = new Date(date).toLocaleDateString(language, {
    month: 'short',
  });
  return monthName;
};
export const getDay = (date) => {
  const extractDate = date.split('T')[0];
  const day = new Date(extractDate).getUTCDate();
  return day;
};
export const getYear = (date) => new Date(date).getUTCFullYear();
export const getLocale = (date, options = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}) => {
  const language = window.cultureInfo
    || document.documentElement.lang
    || navigator.language
    || navigator.languages[0];
  const dateObj = new Date(date);
  const formatedDate = dateObj.toLocaleDateString(language, {
    year: options.year,
    month: options.month,
    day: options.day,
  });
  const formatedTime = dateObj.toLocaleTimeString(language, {
    hourCycle: 'h23',
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${formatedDate} - ${formatedTime}`;
};
